import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Is this really for beginners?',
  a: 'Yes. We explain spinal mechanics simply so anyone can follow the recovery stages, from acute pain to full mobility.'
}, {
  q: 'Can I use this for old injuries?',
  a: 'Absolutely. The system works by restoring proper alignment and stability, which is essential for chronic cases that never fully healed.'
}, {
  q: 'Do I need equipment?',
  a: 'No. The system is designed for home use. All you need is a floor, a chair, and common household items like towels or pillows.'
}, {
  q: 'Is there support?',
  a: 'Yes, you can contact the SIGMA SMART™ team at any time and we will help you with your specific case.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Frequently asked questions" className="bg-transparent" data-id="element-38" data-mp="jpsxbpwhvar6">
      <div className="mx-auto max-w-3xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "14px"
    }} data-id="element-39" data-mp="jrxayzk73o4n">
        <h2 className="text-center font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-40" data-mp="1klvyy71fnvzx">
          ❓ Frequently Asked Questions
        </h2>
        <div className="mt-10 divide-y divide-grape/10 overflow-hidden rounded-2xl border border-grape/15 bg-white" data-id="element-41" data-mp="1aoiufzsp430j">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-42" data-mp="11wpd4b5ceo9w" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-lilac-soft focus:outline-none focus-visible:bg-lilac-soft" data-id="element-43" data-mp="11vny5vl7hhmw">
                  <span className="text-sm font-bold text-plum sm:text-base" data-id="element-44" data-mp="wyxivah86q2j">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-grape" data-id="element-45" data-mp="izo3gd0ufzzm" /> : <PlusIcon className="h-5 w-5 shrink-0 text-plum/40" data-id="element-46" data-mp="mzyguaqytsoi" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-47" data-mp="2pmn3nt8u7pyk">
                  <div className="overflow-hidden" data-id="element-48" data-mp="2kulu4f320dc8">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-plum/70" data-id="element-49" data-mp="2fwalu8seqaw4">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}